import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import Vuelidate from 'vuelidate'
import axios from 'axios'
import i18n  from './locales/i18n';
import { getLanguage, setLanguage } from '@/utils/language-utils'

Vue.use(Vuelidate)
Vue.config.productionTip = false

const token = localStorage.getItem('token');
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}


const urlLang = window.location.pathname.split('/')[1];

if (urlLang === 'es') {
  i18n.locale = 'en';
  setLanguage('en');
} else if (['en', 'gr'].includes(urlLang)) {
  i18n.locale = urlLang;
  setLanguage(urlLang);
} else {
  const saved = getLanguage() || 'en';
  i18n.locale = saved;
  setLanguage(saved);
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount('#app')

// === Optional filter you had ===
Vue.filter('minuteSeconds', (value) => {
  const minutes = Math.floor(value / 60);
  return (
    minutes.toString().padStart(2, "0") +
    ":" +
    (value - minutes * 60).toString().padStart(2, "0")
  );
});
